import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import copyToClipboard from 'copy-to-clipboard';
import branch from 'client/core/branch';
import postWithState from 'client/actions/postWithState';
import {
  TOUR_STATUS_CANCELLED,
} from 'common/tourConstants';
import {
  SR_API_ACTION_ADMIN_MARK_TOUR_NEEDS_RESCHEDULING,
} from 'api/actionTypes';

@branch({
  appUrl: ['env', 'APP_URL'],
})
class SrTourRescheduleLink extends Component {
  static propTypes = {
    tour: PropTypes.object.isRequired,
    listingId: PropTypes.number.isRequired,
    appUrl: PropTypes.string.isRequired,
    reloadDataTableTour: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      showClickedTooltip: false,
    };
    this._unmounting = false;
  }

  componentWillUnmount() {
    this._unmounting = true;
  }

  _onMarkNeedsRescheduling = () => {
    const { tour, dispatch, reloadDataTableTour } = this.props;
    const confirmationMessage = tour.status === TOUR_STATUS_CANCELLED ?
      'Are you sure you want to duplicate this tour and mark it as "Needs Rescheduling?"' :
      'Are you sure you want mark this tour as "Needs Rescheduling"?';

    if (!global.confirm(confirmationMessage)) {
      return;
    }

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_MARK_TOUR_NEEDS_RESCHEDULING,
      payload: {
        tourId: tour.id,
      },
    }).then(reloadDataTableTour);
  }

  _onClickRescheduleLink = (e) => {
    const { tour, listingId, appUrl } = this.props;
    e.preventDefault();
    e.stopPropagation();

    const rescheduleLink = `${appUrl}/tour/${tour.id}/${listingId}/choose-tour-time/reschedule`;

    copyToClipboard(rescheduleLink);

    this.setState({
      showClickedTooltip: true,
    });
    setTimeout(() => {
      if (!this._unmounting) {
        this.setState({
          showClickedTooltip: false,
        });
      }
    }, 2000);
  }

  render() {
    const { tour } = this.props;
    const { showClickedTooltip } = this.state;
    const showRescheduleLink = tour.markedNeedsReschedulingFlag && tour.status !== TOUR_STATUS_CANCELLED;

    return (
      <span
        onClick={showRescheduleLink
          ? this._onClickRescheduleLink
          : this._onMarkNeedsRescheduling
        }
        className='rescheduleLink'
      >
        <span className='secondaryAction'>
          {showRescheduleLink ? 'Reschedule Link' : 'Needs Rescheduling'}
          <span
            className={classnames(
              'copiedMessage',
              'rescheduleCopyMessage',
              showClickedTooltip && 'clicked',
            )}
          >
            Copied!
          </span>
        </span>
      </span>
    );
  }
}

SrTourRescheduleLink.displayName = 'SrTourRescheduleLink';

export default SrTourRescheduleLink;
